// PGCET MCA Mock 9 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "Computers of which generation replaced vacuum tubes with transistors as their main switching component?",
    options: ["A. First generation", "B. Second generation", "C. Third generation", "D. Fourth generation"],
    answer: "B"
  },
  {
    id: 32,
    question: "ENIAC, one of the earliest general-purpose electronic digital computers, was built using thousands of",
    options: ["A. Transistors", "B. Integrated circuits", "C. Vacuum tubes", "D. Microprocessors"],
    answer: "C"
  },
  {
    id: 33,
    question: "Who designed the Analytical Engine in the 19th century and is often called the 'Father of the Computer'?",
    options: ["A. Alan Turing", "B. John von Neumann", "C. Blaise Pascal", "D. Charles Babbage"],
    answer: "D"
  },
  {
    id: 34,
    question: "Which of the following devices acts as both an input device and an output device?",
    options: ["A. Touch screen", "B. Plotter", "C. Flatbed scanner", "D. Light pen"],
    answer: "A"
  },
  {
    id: 35,
    question: "MICR technology, used by banks to process cheques quickly, reads characters that are printed using",
    options: ["A. Barcode lines", "B. Pencil marks in bubbles", "C. Ink containing magnetic iron-oxide particles", "D. Heat-sensitive thermal paper"],
    answer: "C"
  },
  {
    id: 36,
    question: "Taking 1 KB = 1024 bytes, one terabyte (TB) of storage is equal to",
    options: ["A. 2¹⁰ MB", "B. 2²⁰ MB", "C. 2³⁰ MB", "D. 2⁴⁰ MB"],
    answer: "B"
  },
  {
    id: 37,
    question: "In the memory hierarchy of a computer, which of the following has the lowest cost per bit?",
    options: ["A. CPU registers", "B. Cache memory (SRAM)", "C. Main memory (DRAM)", "D. Magnetic hard disk"],
    answer: "D"
  },
  {
    id: 38,
    question: "How many nibbles are there in 2 KB of memory (1 KB = 1024 bytes)?",
    options: ["A. 2048", "B. 4096", "C. 8192", "D. 1024"],
    answer: "B"
  },
  {
    id: 39,
    question: "In MS Excel, the formula =SUM(A1:B3) adds the values of how many cells?",
    options: ["A. 3", "B. 4", "C. 5", "D. 6"],
    answer: "D"
  },
  {
    id: 40,
    question: "In a spreadsheet, cell C1 contains the formula =A1+$B$1. If C1 is copied and pasted into cell C2, the formula in C2 becomes",
    options: ["A. =A1+$B$1", "B. =A2+$B$2", "C. =A2+$B$1", "D. =B2+$B$1"],
    answer: "C"
  },
  {
    id: 41,
    question: "Table EMP has 5 rows and table DEPT has 3 rows. Three EMP rows have a dept_id that matches exactly one DEPT row each, and the other two EMP rows have a dept_id that matches no DEPT row. How many rows are returned by SELECT * FROM EMP LEFT OUTER JOIN DEPT ON EMP.dept_id = DEPT.dept_id?",
    options: ["A. 3", "B. 8", "C. 5", "D. 15"],
    answer: "C"
  },
  {
    id: 42,
    question: "Which view in MS PowerPoint displays thumbnails of all the slides so that they can be easily rearranged?",
    options: ["A. Slide Sorter view", "B. Normal view", "C. Notes Page view", "D. Reading view"],
    answer: "A"
  },
  {
    id: 43,
    question: "Which HTML tag is used to create a hyperlink to another web page?",
    options: ["A. <link>", "B. <a>", "C. <href>", "D. <nav>"],
    answer: "B"
  },
  {
    id: 44,
    question: "Which attribute of the HTML <img> tag specifies the alternate text displayed when the image cannot be loaded?",
    options: ["A. title", "B. src", "C. alt", "D. href"],
    answer: "C"
  },
  {
    id: 45,
    question: "A STUDENT table stores several phone numbers of a student, separated by commas, in a single Phone column. This design violates",
    options: ["A. First Normal Form (1NF)", "B. Second Normal Form (2NF)", "C. Third Normal Form (3NF)", "D. Boyce–Codd Normal Form only"],
    answer: "A"
  },
  {
    id: 46,
    question: "The best-case time complexity of insertion sort, which occurs when the input array is already sorted, is",
    options: ["A. O(n log n)", "B. O(n²)", "C. O(log n)", "D. O(n)"],
    answer: "D"
  },
  {
    id: 47,
    question: "How many swaps does bubble sort perform to sort the array 5, 4, 3, 2, 1 into ascending order?",
    options: ["A. 10", "B. 5", "C. 15", "D. 20"],
    answer: "A"
  },
  {
    id: 48,
    question: "Which sorting algorithm divides the array into two halves, sorts each half recursively and then combines them, typically needing O(n) extra space?",
    options: ["A. Heap sort", "B. Quick sort", "C. Insertion sort", "D. Merge sort"],
    answer: "D"
  },
  {
    id: 49,
    question: "The keys 45, 25, 65, 15, 35, 55, 75, 30 are inserted in that order into an initially empty binary search tree. Taking the root to be at depth 0, the depth of the node containing 30 is",
    options: ["A. 2", "B. 3", "C. 4", "D. 1"],
    answer: "B"
  },
  {
    id: 50,
    question: "The number of edges in a spanning tree of a connected undirected graph with 12 vertices is",
    options: ["A. 12", "B. 11", "C. 13", "D. 66"],
    answer: "B"
  },
  {
    id: 51,
    question: "What is printed by the following C code? int f(int n) { if (n == 0) return 0; return n % 10 + f(n / 10); } printf(\"%d\", f(4587));",
    options: ["A. 24", "B. 4587", "C. 22", "D. 7854"],
    answer: "A"
  },
  {
    id: 52,
    question: "What is printed by the following C code? void p(int n) { if (n > 0) { p(n - 1); printf(\"%d \", n); } } called as p(4);",
    options: ["A. 4 3 2 1", "B. 0 1 2 3 4", "C. 1 2 3 4", "D. 1 2 3"],
    answer: "C"
  },
  {
    id: 53,
    question: "What is printed by the following C code? int g(int a, int b) { return b == 0 ? a : g(b, a % b); } printf(\"%d\", g(84, 36));",
    options: ["A. 6", "B. 18", "C. 36", "D. 12"],
    answer: "D"
  },
  {
    id: 54,
    question: "Using a Caesar cipher with a right shift of 3, the plaintext word CODE is encrypted as",
    options: ["A. FRGH", "B. DPEF", "C. ERFG", "D. FRHG"],
    answer: "A"
  },
  {
    id: 55,
    question: "In public-key cryptography, to send a confidential message that only Bob can read, Alice should encrypt it using",
    options: ["A. Alice's private key", "B. Alice's public key", "C. Bob's private key", "D. Bob's public key"],
    answer: "D"
  }
];

export default pgcetmcaComputerAwareness;
